import * as React from 'react'
import { BlogCategory } from '../../common/typings/enums'
import HorizontalList from '../HorizontalList'
import './style.scss'

interface TagsProps {
  tags: string[]
  initiallyActive?: string | BlogCategory
  onChange: (value: string) => void
  isItLink?: boolean
}

const Tags: React.FC<TagsProps> = ({
  tags,
  initiallyActive,
  onChange,
  isItLink
}) => {
  const [selectedTag, setSelectedTag] = React.useState(initiallyActive ? initiallyActive : '')
  const tagChangedHandler = (selectedTag: string) => {
    setSelectedTag(selectedTag)
    onChange(selectedTag)
  }
  return (
    <div className="Tags">
      <HorizontalList
        items={tags}
        active={selectedTag}
        className="FontS"
        onChange={tagChangedHandler}
        isItLink={isItLink}
      />
    </div>
  )
}

export default Tags
